import { CDNImage } from '~/components/ui/CDNImage'

function MirrorFooter() {
  const QRCodeList = [
    {
      key: 1,
      url: '/images/mirror/mirror-qrcode.jpg',
      title: '小程序体验',
    },
    {
      key: 2,
      url: '/images/mirror/personal-qrcode.jpg',
      title: '个人商务咨询',
    },
    {
      key: 3,
      url: '/images/mirror/business-qrcode.jpg',
      title: '企业商务咨询',
    },
  ]

  return (
    <footer className="border-t border-neutral-600 py-[48px] flex items-center justify-between px-[64px]">
      <div>
        <CDNImage src="/images/mirror/mirror-logo-black.svg" />
        <div className="texs-sm text-neutral-400 font-semibold ml-[18px] leading-none">
          AI 时代的全能影像馆
        </div>
        <div className="texs-xs text-neutral-500 mt-4 ml-[18px]">
          &copy; 2024 WujieAI All rights reserved.
        </div>
      </div>
      <div className="flex">
        {QRCodeList.map(it => (
          <div key={it.key} className="mr-8 last:mr-0">
            <div className="w-[96px] h-[96px] bg-neutral-700 rounded-[8px] p-1">
              <CDNImage className="w-full h-full" src={it.url} />
            </div>
            <div className="texs-xs text-neutral-400 font-semibold mt-2 text-center">
              {it.title}
            </div>
          </div>
        ))}
      </div>
    </footer>
  )
}

export default MirrorFooter
